// OTStatusScreen.tsx
import * as Styled from './OTStatusScreen.styled';

interface OTStatusScreenProps {
  status: string;
}

export default function OTStatusScreen({ status }: OTStatusScreenProps) {
  return (
    <Styled.Wrapper>
      <Styled.BackgroundVideo autoPlay loop muted playsInline>
        <source
          src="https://poly-ai-public.s3.eu-west-2.amazonaws.com/PolyAI+Videos/redirect.mp4"
          type="video/mp4"
        />
      </Styled.BackgroundVideo>
      <Styled.BottomText>{status}</Styled.BottomText>
    </Styled.Wrapper>
  );
}
